/**
 * Widget hang — memory-only token + push-to-talk (Laravel utterance bridge).
 */

/**
 * @param {{ mintVoiceToken: Function, sendVoiceUtterance: Function }} api
 */
export function createVoiceSession(api) {
    /** @type {{ token: string, expiresAt: number, voiceWsUrl: string|null }|null} */
    let session = null;

    async function ensureToken() {
        if (session !== null && Date.now() < session.expiresAt) {
            return session;
        }

        const data = await api.mintVoiceToken();
        if (! data?.token) {
            session = null;

            return null;
        }

        const expiresIn = Number(data.expires_in ?? 900);
        session = {
            token: data.token,
            expiresAt: Date.now() + Math.max(60, expiresIn) * 1000 - 30_000,
            voiceWsUrl: typeof data.voice_ws_url === 'string' ? data.voice_ws_url : null,
        };

        return session;
    }

    function clear() {
        session = null;
    }

    return { ensureToken, clear };
}
